import React from 'react';
import ReservationProgressBar from './ReservationProgressBar';

/**
 * Fixed bottom bar used across payment/booking/detail pages.
 * Provides consistent structure: white bg, border-t, safe-area padding.
 *
 * @param {string} visibility - 'always' (default) | 'mobile-only' (lg:hidden)
 * @param {number} step - current reservation step (optional, shows progress bar when provided)
 * @param {number} totalSteps - total reservation steps (optional)
 * @param {React.ReactNode} children - content (typically price left + button right)
 */
export default function StickyBottomBar({ children, visibility = 'always', step, totalSteps }) {
  const visibilityClass = visibility === 'mobile-only' ? 'lg:hidden' : '';

  return (
    <div data-sticky-bottom-bar className={`${visibilityClass} fixed bottom-0 left-0 right-0 bg-white border-t border-mono-200 shadow-card z-30 pb-safe`}>
      {step && totalSteps && (
        <ReservationProgressBar step={step} total={totalSteps} />
      )}
      <div className="max-w-content mx-auto px-4 sm:px-5 py-3 sm:py-4 flex items-center justify-between">
        {children}
      </div>
    </div>
  );
}
